import { customerApi } from "../../../utils/apiConfig";

const getAuthHeaders = () => ({
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});

const getMultipartAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  },
});

// QMAD Demo / Quality File Manager API ------>

// Folder Routes

export const seedDefaultQualityFolders = async (data = {}) => {
  const response = await customerApi.post(
    "/seedDefaultQualityFolders",
    data,
    getAuthHeaders()
  );
  return response.data;
};

export const createQualityFolder = async (data) => {
  const response = await customerApi.post(
    "/createQualityFolder",
    data,
    getAuthHeaders()
  );
  return response.data;
};

export const getQualityFolderTree = async (data = {}) => {
  const response = await customerApi.post(
    "/getQualityFolderTree",
    data,
    getAuthHeaders()
  );
  return response.data;
};

export const updateQualityFolder = async (data) => {
  const response = await customerApi.post(
    "/updateQualityFolder",
    data,
    getAuthHeaders()
  );
  return response.data;
};

export const deleteQualityFolder = async (data) => {
  const response = await customerApi.post(
    "/deleteQualityFolder",
    data,
    getAuthHeaders()
  );
  return response.data;
};

// Document Routes

export const createQualityDocument = async (formData) => {
  const response = await customerApi.post(
    "/createQualityDocument",
    formData,
    getMultipartAuthHeaders()
  );
  return response.data;
};

export const getQualityDocumentList = async (data = {}) => {
  const response = await customerApi.post(
    "/getQualityDocumentList",
    data,
    getAuthHeaders()
  );
  return response.data;
};

export const getQualityDocumentDetail = async (data) => {
  const response = await customerApi.post(
    "/getQualityDocumentDetail",
    data,
    getAuthHeaders()
  );
  return response.data;
};

export const updateQualityDocument = async (data) => {
  const response = await customerApi.post(
    "/updateQualityDocument",
    data,
    getAuthHeaders()
  );
  return response.data;
};

export const moveQualityDocument = async (data) => {
  const response = await customerApi.post(
    "/moveQualityDocument",
    data,
    getAuthHeaders()
  );
  return response.data;
};

export const uploadQualityDocumentVersion = async (formData) => {
  const response = await customerApi.post(
    "/uploadQualityDocumentVersion",
    formData,
    getMultipartAuthHeaders()
  );
  return response.data;
};

export const changeQualityDocumentStatus = async (data) => {
  const response = await customerApi.post(
    "/changeQualityDocumentStatus",
    data,
    getAuthHeaders()
  );
  return response.data;
};

export const deleteQualityDocument = async (data) => {
  const response = await customerApi.post(
    "/deleteQualityDocument",
    data,
    getAuthHeaders()
  );
  return response.data;
};

export const trackQualityDocumentAccess = async (data) => {
  const response = await customerApi.post(
    "/trackQualityDocumentAccess",
    data,
    getAuthHeaders()
  );
  return response.data;
};

export const getQualityDocumentLogs = async (data = {}) => {
  const response = await customerApi.post(
    "/getQualityDocumentLogs",
    data,
    getAuthHeaders()
  );
  return response.data;
};

// <------ QMAD Demo / Quality File Manager API
